import MailSettings from './sections/MailSettings';
import SupplementsSettings from './sections/SupplementsSettings';
import ReindexSettings from './sections/ReindexSettings';

/**
 * Registry of the settings sections. To add a menu, append an entry here and add its
 * `settings.sections.<key>` translations: the page builds its navigation from this list.
 *
 * - key:         used in the url (/administration/settings/<key>) and in the translations
 * - icon:        vue-awesome icon name
 * - component:   section component
 * - isAllowed:   optional (store) => boolean, defaults to allowed for everyone who can open the settings
 */
export default [
  {
    key: 'email',
    icon: 'envelope',
    component: MailSettings,
    isAllowed: store => store.getters['security/isSettingsAdmin']
  },
  {
    key: 'supplements',
    icon: 'list-ul',
    component: SupplementsSettings,
    isAllowed: store => store.getters['security/hasOffersRole']('write')
  },
  {
    key: 'reindexing',
    icon: 'sync',
    component: ReindexSettings,
    isAllowed: store => store.getters['security/isSettingsAdmin']
  }
];
